//@ts-nocheck
const chatStyleURL = (assetsUrl) => `${assetsUrl}/chat/style.css`;
const luxonScriptURL = "https://cdnjs.cloudflare.com/ajax/libs/luxon/3.4.4/luxon.min.js";
const emojiPickerElementURL = "https://cdn.skypack.dev/emoji-picker-element@^1";
const insertTextScriptURL = "https://cdn.jsdelivr.net/npm/insert-text-at-cursor@0.3.0/index.js";
const bootstrapIconsURL = "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
var scriptTagsSrcs = [
  {
    src: "https://cdn.jsdelivr.net/gh/manuelmhtr/countries-and-timezones@latest/dist/index.min.js",
    head: true,
  },
  {
    src: "https://js.pusher.com/7.0/pusher.min.js",
    head: true,
  },
];

function injectScriptTags(assetsUrl) {
  var bodyElement = document.querySelector("body");
  var headElement = document.head;
  scriptTagsSrcs.forEach(function (url) {
    var scriptElement = document.createElement("script");
    if (url.type) {
      scriptElement.type = url.type;
    }
    if (url.dynamic) {
      scriptElement.type = assetsUrl + url.src;
      bodyElement.appendChild(scriptElement);
    } else {
      scriptElement.src = url.src;
      headElement.appendChild(scriptElement);
    }
  });
}

// Function to inject CSS links into the page
function injectCSSLinks(assetsUrl) {
  // Create link elements for each CSS file
  const bootstrapIconsLink = document.createElement("link");
  bootstrapIconsLink.rel = "stylesheet";
  bootstrapIconsLink.href = bootstrapIconsURL;

  const chatStyleLink = document.createElement("link");
  chatStyleLink.rel = "stylesheet";
  chatStyleLink.href = chatStyleURL(assetsUrl);

  // Append the link elements to the head of the document
  document.head.appendChild(bootstrapIconsLink);
  document.head.appendChild(chatStyleLink);
}

function injectBaseResources() {
  // Create script elements for each script file
  const luxonScript = document.createElement("script");
  luxonScript.src = luxonScriptURL;
  luxonScript.integrity = "sha512-dUlSLLkxslGILhPdCkALwk4szPhp3xmZIKFtlUD+O9Lslq41Aksmdt5OGqpomDoT4FsCUH70jQU8ezZHI3v1RQ==";
  luxonScript.crossOrigin = "anonymous";
  luxonScript.referrerPolicy = "no-referrer";

  const emojiPickerElementScript = document.createElement("script");
  emojiPickerElementScript.type = "module";
  emojiPickerElementScript.src = emojiPickerElementURL;

  const insertTextScript = document.createElement("script");
  insertTextScript.type = "module";
  insertTextScript.src = insertTextScriptURL;

  // Append the script elements to the body of the document
  document.body.appendChild(luxonScript);
  document.body.appendChild(emojiPickerElementScript);
  document.body.appendChild(insertTextScript);
}

function renderChatBoxDefault(instanceGUID) {
  const chatBox = document.createElement("div");
  chatBox.id = `chat-box-${instanceGUID}`;
  chatBox.className = "chat-box-default";
  chatBox.style.display = "none";

  const root = document.createElement("div");
  root.id = `root-${instanceGUID}`;

  chatBox.appendChild(root);

  document.body.appendChild(chatBox);
}

function renderChatEmbDefault(instanceGUID) {
  const chatBox = document.createElement("div");
  chatBox.id = `chat-box-${instanceGUID}`;
  chatBox.className = "chat-emb-default";

  const root = document.createElement("div");
  root.id = `root-${instanceGUID}`;

  chatBox.appendChild(root);

  document.body.appendChild(chatBox);
}

function renderChatModDefault(instanceGUID) {
  const chatBox = document.createElement("div");
  chatBox.id = `chat-box-${instanceGUID}`;
  chatBox.className = "chat-mod-default";

  const root = document.createElement("div");
  root.id = `root-${instanceGUID}`;

  chatBox.appendChild(root);

  document.body.appendChild(chatBox);
}

function renderChatButton(instanceGUID) {
  const container = document.createElement("div");
  container.id = `chat-button-container-${instanceGUID}`;
  container.style.cssText = `
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 99999;
        display: flex;
    `;

  const logoContainer = document.createElement("div");
  logoContainer.id = `logo-image-${instanceGUID}`;
  logoContainer.style.display = "none";
  logoContainer.style.alignItems = "center";

  const logoText = document.createElement("span");
  logoText.style.color = "#a9a9a9";
  logoText.textContent = "powered by";

  const logoLink = document.createElement("a");
  logoLink.target = "_blank";
  logoLink.href = "https://ebsss.com";

  const logoImage = document.createElement("img");
  logoImage.src = "https://web.iclient.app/logo.png";
  logoImage.width = "110";
  logoImage.height = "40";
  logoImage.style.alignSelf = "center";
  logoImage.style.display = "block";

  const chatButton = document.createElement("button");
  chatButton.id = `chat-button-${instanceGUID}`;
  chatButton.style.cssText = `
        background-color: rgb(0, 123, 255);
        color: white;
        border: none;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    `;

  container.appendChild(logoContainer);
  logoContainer.appendChild(logoText);
  logoLink.appendChild(logoImage);
  logoContainer.appendChild(logoLink);
  container.appendChild(chatButton);

  document.body.appendChild(container);
}

function renderImageModal(instanceGUID) {
  const modalContainer = document.createElement("div");
  modalContainer.id = `modal-image-${instanceGUID}`;
  modalContainer.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        display: none;
        justify-content: center;
        align-items: center;
        z-index: 100000000000;
    `;

  const modalContent = document.createElement("div");
  modalContent.style.cssText = `
        background: white;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        margin-left: auto;
        margin-right: auto;
        display: flex;
        flex-direction: column;
        height: 100%;
        max-height: 100%;
    `;

  const closeButtonContainer = document.createElement("div");
  closeButtonContainer.style.cssText = `
        flex-direction: row;
        display: flex;
    `;

  const closeButton = document.createElement("div");
  closeButton.onclick = "closeImageModal()";
  closeButton.className = "close-button";
  closeButton.style.cssText = `
        margin-left: auto;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    `;

  closeButton.innerHTML = `
        <svg width="22px" height="22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z" fill="#0F0F0F"/>
        </svg>
    `;

  const modalImage = document.createElement("img");
  modalImage.id = `image-modal-${instanceGUID}`;
  modalImage.style.cssText = `
        width: 100%;
        min-height: auto;
        max-height: calc(100% - 30px);
        margin-top: auto;
        margin-bottom: auto;
    `;

  modalContent.appendChild(closeButtonContainer);
  closeButtonContainer.appendChild(closeButton);
  modalContent.appendChild(modalImage);
  modalContainer.appendChild(modalContent);

  document.body.appendChild(modalContainer);
}

function basicToggler(id, dpType) {
  if (dpType === "pop") {
    document.querySelector(id).classList.toggle("chat-box-default");
    document.querySelector(id).classList.toggle("chat-box-modal");
  }
  if (dpType === "emb") {
    document.querySelector(id).classList.toggle("chat-emb-default");
    document.querySelector(id).classList.toggle("chat-emb-modal");
  }
  if (dpType === "mod") {
    document.querySelector(id).classList.toggle("chat-mod-default");
    document.querySelector(id).classList.toggle("chat-mod-modal");
  }
}

function chatPopFunctions(instanceGUID) {
  if (!window.CHAT_INSTANCE) {
    window.CHAT_INSTANCE = {
      emb: 0,
      pop: 1,
      mod: 0,
    };
  } else {
    window.CHAT_INSTANCE = {
      ...window.CHAT_INSTANCE,
      pop: window.CHAT_INSTANCE.pop + 1,
    };
  }

  if (!window.TOGGLE_MODAL) {
    window.TOGGLE_MODAL = {
      [`toggle_${instanceGUID}`]: (id) => basicToggler(id, "pop"),
    };
  } else {
    window.TOGGLE_MODAL = {
      ...window.TOGGLE_MODAL,
      [`toggle_${instanceGUID}`]: (id) => basicToggler(id, "pop"),
    };
  }
}

function chatModFunctions(instanceGUID, btnToSetOpenChatModal) {
  if (!window.CHAT_INSTANCE) {
    window.CHAT_INSTANCE = {
      emb: 0,
      pop: 0,
      mod: 1,
    };
  } else {
    window.CHAT_INSTANCE = {
      ...window.CHAT_INSTANCE,
      mod: window.CHAT_INSTANCE.mod + 1,
    };
  }

  if (!window.TOGGLE_MODAL) {
    window.TOGGLE_MODAL = {
      [`toggle_${instanceGUID}`]: (id) => basicToggler(id, "mod"),
    };
  } else {
    window.TOGGLE_MODAL = {
      ...window.TOGGLE_MODAL,
      [`toggle_${instanceGUID}`]: (id) => basicToggler(id, "mod"),
    };
  }

  btnToSetOpenChatModal.addEventListener("click", () => {
    window.TOGGLE_MODAL[`toggle_${instanceGUID}`]("#chat-box-" + `${instanceGUID}`);
  });
}

function chatEmbFunctions(instanceGUID) {
  if (!window.CHAT_INSTANCE) {
    window.CHAT_INSTANCE = {
      emb: 1,
      pop: 0,
      mod: 0,
    };
  } else {
    window.CHAT_INSTANCE = {
      ...window.CHAT_INSTANCE,
      emb: window.CHAT_INSTANCE.emb + 1,
    };
  }

  if (!window.TOGGLE_MODAL) {
    window.TOGGLE_MODAL = {
      [`toggle_${instanceGUID}`]: (id) => basicToggler(id, "emb"),
    };
  } else {
    window.TOGGLE_MODAL = {
      ...window.TOGGLE_MODAL,
      [`toggle_${instanceGUID}`]: (id) => basicToggler(id, "emb"),
    };
  }
}

function injectChatScriptSelector(type, instanceGUID, btnToSetOpenChatModal = null) {
  if (type === "pop") {
    return chatPopFunctions(instanceGUID);
  }
  if (type === "mod") {
    return chatModFunctions(instanceGUID, btnToSetOpenChatModal);
  }
  if (type === "emb") {
    return chatEmbFunctions(instanceGUID);
  }
}

const toggleChatIconToClose = (sfx) => {
  setTimeout(() => {
    if (document.querySelector("#close-chat-button")) {
      document.querySelector("#close-chat-button").style.display = document.querySelector("#close-chat-button").style.display === "none" ? "block" : "none";
    }

    if (document.querySelector("#alternative-icon")) {
      document.querySelector("#alternative-icon").style.display = document.querySelector("#alternative-icon").style.display === "none" ? "block" : "none";
    }

    if (document.querySelector("#logo-image-" + sfx)) {
      document.querySelector("#logo-image-" + sfx).style.display = document.querySelector("#logo-image-" + sfx).style.display === "none" ? "flex" : "none";
    }
  }, 50);
};

function renderChatContainer(sufixGUID) {
  const modalImage = document.getElementById("modal-image-" + sufixGUID);
  const imageModal = document.getElementById("image-modal-" + sufixGUID);
  const imageLogo = document.getElementById("logo-image-" + sufixGUID);
  const chatButton = document.getElementById("chat-button-" + sufixGUID);

  function renderChatPreviewBox(msgPreview, bgPreview, headerBgPreview) {
    // Create main container element
    var chatBox = document.createElement("div");
    chatBox.id = "chat-box-preview-" + sufixGUID;
    chatBox.style.position = "fixed";
    chatBox.style.bottom = "80px";
    chatBox.style.right = "10px";
    chatBox.style.width = "300px";
    chatBox.style.backgroundColor = "white";
    chatBox.style.boxShadow = "rgba(0, 0, 0, 0.1) 0px 4px 6px";
    chatBox.style.display = "block";
    chatBox.style.zIndex = "99999";
    chatBox.style.borderRadius = "10px";
    chatBox.style.height = "auto";
    chatBox.style.cursor = "pointer";

    // Create close button (X)
    var closeButton = document.createElement("div");
    closeButton.innerHTML = `
    <?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
    <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z" fill="#0F0F0F"/>
    </svg>
    `;
    closeButton.style.position = "absolute";
    closeButton.style.top = "5px";
    closeButton.style.right = "5px";
    closeButton.style.cursor = "pointer";
    closeButton.style.fontWeight = "bold";
    closeButton.style.fontSize = "16px";
    closeButton.style.color = "#555";
    closeButton.style.padding = "5px";
    closeButton.style.borderRadius = "50%";
    closeButton.style.width = "25px";
    closeButton.style.height = "25px";
    closeButton.style.textAlign = "center";
    closeButton.style.lineHeight = "15px";
    closeButton.style.zIndex = 99999999999;
    closeButton.id = "chat-box-preview-close-" + sufixGUID;

    // Create inner elements
    var innerDiv = document.createElement("div");
    innerDiv.id = "root-" + sufixGUID;
    var innerDiv2 = document.createElement("div");
    innerDiv2.className = "ebsss-widget-container-" + sufixGUID;
    var innerDiv3 = document.createElement("div");
    innerDiv3.className = "ebsss-widget-chat-area-" + sufixGUID;
    var innerDiv4 = document.createElement("div");
    innerDiv4.style.paddingTop = "15px";
    innerDiv4.style.flexDirection = "row";
    innerDiv4.style.display = "flex";
    innerDiv4.style.justifyContent = "space-between";
    innerDiv4.style.borderRadius = "10px";
    innerDiv4.style.background = `url("${bgPreview}") 0% 0% / cover`;
    innerDiv4.style.height = "auto";

    var innerDiv5 = document.createElement("div");
    innerDiv5.style.display = "flex";
    innerDiv5.style.margin = "auto";
    innerDiv5.style.flexDirection = "column";
    innerDiv5.style.alignItems = "center";
    innerDiv5.style.height = "auto";

    var img = document.createElement("img");
    img.src = headerBgPreview;
    img.alt = "Chat Picture";
    img.style.borderRadius = "50%";
    img.style.width = "35px";
    img.style.height = "35px";

    var innerDiv6 = document.createElement("div");
    var p = document.createElement("p");
    p.textContent = msgPreview;
    p.style.fontSize = "12px";
    p.style.padding = "10px";

    // Append elements to each other
    innerDiv6.appendChild(p);
    innerDiv5.appendChild(img);
    innerDiv5.appendChild(innerDiv6);
    innerDiv4.appendChild(innerDiv5);
    innerDiv3.appendChild(innerDiv4);
    innerDiv2.appendChild(innerDiv3);
    innerDiv.appendChild(innerDiv2);
    chatBox.appendChild(innerDiv);
    chatBox.appendChild(closeButton);

    closeButton.addEventListener(
      "click",
      function (e) {
        e.stopPropagation();
        console.log("closeButton clicked");
        chatBox.style.display = "none";
        //imageLogo.style.display = "none";
        localStorage.setItem("chat-box-preview-closed-" + sufixGUID, "1");
        let tmr = setTimeout(() => {
          document.getElementById("chat-box-preview-" + sufixGUID).style.display = "none";
          clearTimeout(tmr);
        }, 1);
      },
      false
    );

    chatBox.addEventListener(
      "click",
      (e) => {
        e.stopPropagation();
        console.log("chatBox clicked");
        document.getElementById("chat-box-" + sufixGUID).style.display = "block";
        document.getElementById("chat-box-preview-" + sufixGUID).style.display = "none";
        //imageLogo.style.display = 'flex';
        if (localStorage.getItem("OPENED_BY_SCRIPT")) {
          localStorage.removeItem("OPENED_BY_SCRIPT");
          return;
        }
        toggleChatIconToClose(sufixGUID);
      },
      false
    );

    return chatBox;
  }

  function showImageModal(src) {
    modalImage.style.display = "flex";
    imageModal.src = src;
  }

  function closeImageModal() {
    modalImage.style.display = "none";
    imageModal.src = "";
  }

  document?.addEventListener("DOMContentLoaded", () => {
    const chatButton = document.getElementById("chat-button-" + sufixGUID);
    const chatBox = document.getElementById("chat-box-" + sufixGUID);

    if (!chatBox || !chatButton) return;

    function updateWidth() {
      const windowWidth = window.innerWidth;
      if (windowWidth < 400) {
        chatBox.style.width = "95%";
        chatBox.style.height = "80%";
      } else {
        chatBox.style.width = "400px";
        chatBox.style.height = "645px";
      }
    }

    window?.addEventListener("resize", updateWidth);

    chatButton.addEventListener("click", function () {
      //   imageLogo.style.display =
      //     imageLogo.style.display === "none" ? "flex" : "none";
      chatBox.style.display = chatBox.style.display === "none" ? "block" : "none";
      if (document.querySelector("#chat-box-preview-" + sufixGUID)) {
        document.querySelector("#chat-box-preview-" + sufixGUID).style.display = "none";
      }
      if (localStorage.getItem("OPENED_BY_SCRIPT")) {
        localStorage.removeItem("OPENED_BY_SCRIPT");
        return;
      }
      toggleChatIconToClose(sufixGUID);
    });
  });

  window?.addEventListener("message", (event) => {
    // if (event.data.includes("SHOW_PREVIEW_" + sufixGUID)) {
    //   let existingElement = document.getElementById("chat-button-container-" + sufixGUID);
    //   let existingBox = document.getElementById("chat-box-" + sufixGUID);
    //   if (!existingElement || !existingBox) return;
    //   let [msg, bg, header] = event.data.replace("SHOW_PREVIEW_" + sufixGUID + "#", "").split("#");
    //   existingBox.style.display = "none";
    //   let parentElement = existingElement.parentElement;
    //   if (localStorage.getItem("chat-box-preview-closed-" + sufixGUID) !== "1") {
    //     parentElement.insertBefore(renderChatPreviewBox(msg, bg, header), existingElement.nextSibling);
    //   } else {
    //     imageLogo.style.display = "none";
    //   }
    // }
    // if (event.data.includes("SHOW_IMAGE_MODAL_" + sufixGUID)) {
    //   showImageModal(event.data.split("#")[1]);
    // }
    // if (event.data.includes("CHAT_ICON_" + sufixGUID)) {
    //   if (!document.getElementById("chat-button-" + sufixGUID)) return;
    //   const getIconName = event.data.split("#");
    //   const changeIcon = (name) => {
    //     let el = "";
    //     let closeSvg = `<svg id='close-chat-button' style='display:none !important;align-self:center !important;' width="38px" height="38px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="12" cy="12" r="10" stroke="#fff" stroke-width="1.5"/> <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/> </svg>`;
    //     if (name === "square_black") {
    //       el = `
    //             ${closeSvg}
    //             <svg style='display:block !important;align-self:center !important;' version="1.1" data-type="square_black" id='alternative-icon' xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" width="50" height="50" xml:space="preserve"> <style type="text/css"> .st0chat{fill:#fff;} </style> <path class="st0chat" d="M41.5,19.3h-23c-1.7,0-3,1.3-3,3V35c0,1.7,1.3,3,3,3h4.3v6.6l6-6.7h12.7c1.7,0,3-1.3,3-3V22.3 C44.5,20.7,43.1,19.3,41.5,19.3z M22.2,24.8h8.4c0.3,0,0.6,0.3,0.6,0.6S30.9,26,30.6,26h-8.4c-0.3,0-0.6-0.3-0.6-0.6 S21.8,24.8,22.2,24.8z M38.4,33.2H22.2c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h16.3c0.3,0,0.6,0.3,0.6,0.6S38.8,33.2,38.4,33.2z M38.4,29.6H22.2c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h16.3c0.3,0,0.6,0.3,0.6,0.6C39,29.3,38.8,29.6,38.4,29.6z"></path> </svg>
    //             `;
    //     }
    //     if (name === "square_white") {
    //       el = `
    //             ${closeSvg}
    //             <svg style='display:block !important;align-self:center !important;' version="1.1" data-type="square_white" id='alternative-icon' xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" width="50" height="50" xml:space="preserve"> <style type="text/css"> .st0chat{fill:#fff;} </style> <path class="st0chat" d="M40.9,18.3H20.1c-2.2,0-3.9,1.8-3.9,3.9l0,0V35c0,2.2,1.8,3.9,3.9,3.9v5.8l8.3-5.7h12.4c2.2,0,3.9-1.8,3.9-3.9 c0,0,0,0,0,0V22.3C44.8,20.1,43,18.3,40.9,18.3z M43.1,35c0,1.2-1,2.3-2.3,2.3h-13l-6.1,4.2v-4.2h-1.7c-1.2,0-2.3-1-2.3-2.3 c0,0,0,0,0,0V22.3c0-1.2,1-2.3,2.3-2.3l0,0h20.7c1.2,0,2.3,1,2.3,2.3C43.1,22.3,43.1,35,43.1,35z"></path> <path class="st0chat" d="M23.8,24.3h13.3V26H23.8V24.3z"></path> <path class="st0chat" d="M23.8,27.8h13.3v1.7H23.8V27.8z"></path> <path class="st0chat" d="M23.8,31.4h13.3v1.7H23.8V31.4z"></path> </svg>
    //             `;
    //     }
    //     if (name === "round_left") {
    //       el = `
    //             ${closeSvg}
    //             <svg style='display:block !important;align-self:center !important;' xmlns="http://www.w3.org/2000/svg" data-type="round_left" id='alternative-icon' viewBox="0 0 60 60" width="50" height="50"> <path d="M30.5,17.38c-8,0-14.43,5.72-14.43,12.74A11.84,11.84,0,0,0,19,37.82a4.69,4.69,0,0,1-1.73,2.05A1.1,1.1,0,0,0,16.79,41a1.09,1.09,0,0,0,.92.84,9.78,9.78,0,0,0,1.37.09,8.4,8.4,0,0,0,4-.93,15.84,15.84,0,0,0,7.44,1.83c8,0,14.43-5.72,14.43-12.74S38.47,17.38,30.5,17.38Zm0,24a14.33,14.33,0,0,1-7.09-1.84,0.71,0.71,0,0,0-.36-0.09,0.75,0.75,0,0,0-.37.1,7,7,0,0,1-3.89.93,6.46,6.46,0,0,0,1.73-2.59,0.73,0.73,0,0,0-.15-0.74,10.26,10.26,0,0,1-2.86-7.06c0-6.23,5.83-11.3,13-11.3s13,5.07,13,11.3S37.66,41.42,30.5,41.42Z" fill="#fff"></path> <circle cx="30.5" cy="30.12" r="0.93" fill="#fff"></circle> <circle cx="26.51" cy="30.12" r="0.93" fill="#fff"></circle> <circle cx="34.48" cy="30.12" r="0.93" fill="#fff"></circle> </svg>
    //             `;
    //     }
    //     if (name === "round_right") {
    //       el = `
    //             ${closeSvg}
    //             <svg style='display:block !important;align-self:center !important;' id='alternative-icon' version="1.1" data-type="round_right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" width="50" height="50" xml:space="preserve"> <style type="text/css"> .st0chat{fill:#fff;} </style> <path class="st0chat" d="M30.5,17.3c8,0,14.4,5.7,14.4,12.7c0,2.8-1.1,5.6-2.9,7.7c0.4,0.8,1,1.5,1.7,2c0.4,0.2,0.6,0.7,0.5,1.1 c-0.1,0.4-0.5,0.8-0.9,0.8c-0.5,0.1-0.9,0.1-1.4,0.1c-1.4,0-2.8-0.3-4-0.9c-2.3,1.2-4.8,1.8-7.4,1.8c-8,0-14.4-5.7-14.4-12.7 S22.5,17.3,30.5,17.3z M30.5,41.3c2.5,0,4.9-0.6,7.1-1.8c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1c1.2,0.7,2.5,1,3.9,0.9 c-0.8-0.7-1.4-1.6-1.7-2.6c-0.1-0.3,0-0.5,0.2-0.7c1.8-1.9,2.8-4.4,2.9-7.1c0-6.2-5.8-11.3-13-11.3s-13,5.1-13,11.3 S23.4,41.3,30.5,41.3L30.5,41.3z"></path> <circle class="st0chat" cx="30.5" cy="30" r="0.9"></circle> <circle class="st0chat" cx="34.5" cy="30" r="0.9"></circle> <circle class="st0chat" cx="26.5" cy="30" r="0.9"></circle> </svg>
    //             `;
    //     }
    //     const parser = new DOMParser();
    //     const doc = parser.parseFromString(el, "text/html");
    //     const bodyElement = doc.body;
    //     const bodyHTML = doc.querySelector("html");
    //     bodyElement.style.backgroundColor = "transparent";
    //     bodyElement.style.display = "flex";
    //     bodyHTML.style.display = "flex";
    //     if (document.querySelectorAll("html")?.length > 1) {
    //       return;
    //     }
    //     document.getElementById("chat-button-" + sufixGUID)?.appendChild(doc.documentElement);
    //   };
    //   changeIcon(getIconName[1]);
    // }
  });
}

export class EBSSSChatModule {
  constructor({ guid, type, chatChannelId, tenantId, tenantApiBaseURL, assetsBaseUrl, domainBaseURL, pusherCluster, pusherClient, modalOpenButton }) {
    console.log("Starting Chat...");
    this.guid = guid;
    this.type = type;
    this.chatChannelId = chatChannelId;
    this.tenantId = tenantId;
    this.tenantApiBaseURL = tenantApiBaseURL;
    this.assetsBaseUrl = assetsBaseUrl;
    this.domainBaseURL = domainBaseURL;
    this.pusherCluster = pusherCluster;
    this.pusherClient = pusherClient;

    if (modalOpenButton) {
      this.modalOpenButton = modalOpenButton;
    } else {
      this.modalOpenButton = null;
    }
  }

  init() {
    // if (this.type === "pop") {
    //   renderChatButton(this.guid);
    //   renderChatBoxDefault(this.guid);
    // }
    // if (this.type === "emb") {
    //   renderChatEmbDefault(this.guid);
    // }
    // if (this.type === "mod") {
    //   renderChatModDefault(this.guid);
    // }
    // renderImageModal(this.guid);
    injectCSSLinks(this.assetsBaseUrl);
    // injectChatScriptSelector(this.type, this.guid, this.modalOpenButton);
    injectBaseResources();
    injectScriptTags(this.assetsBaseUrl);
    // if (this.type === "pop") {
    //   renderChatContainer(this.guid);
    // }
  }
}
